import { Address } from "viem";

import { Loan } from "./data/types";

/**
 * Reserve accounts whose loans must not be paid from this app. For loans under
 * these accounts every quote-derived figure renders as `--` instead of a number,
 * the payment history is withheld, and repayment is blocked.
 *
 * TWO DISTINCT REASONS LAND AN ACCOUNT HERE, and they have different exit
 * conditions — do NOT empty this list wholesale:
 *
 *   1. A BROKEN `quote`. The original reason: submitting a payment against a bad
 *      quote would move the wrong amount of funds. The two accounts quarantined
 *      on 2026-07-27 were cleared after LoanRouterV2 v1.2 (2026-07-28) fixed the
 *      underlying bug — verified against both of their still-Active loans, each
 *      returning a plausible non-zero principal/interest split rather than
 *      reverting or returning garbage. None remain.
 *
 *   2. AN OPERATIONAL HOLD. The quote is fine; the loan must simply not be paid
 *      yet. `deadlines()` makes a loan payable from the moment it is originated
 *      (the first period's "previous deadline" IS the origination timestamp, see
 *      `useLoanTimestamp.ts`), so a freshly-originated loan is live and payable
 *      the same day — with no back-office lever to stop it. This list is that
 *      lever until one exists.
 *
 * Keyed on the reserve account (`loan.borrower`), so it covers every loan held
 * by the account — check the blast radius before adding, since a borrower EOA may
 * own several reserve accounts and an account may hold several loans.
 *
 * This is a client-side UI gate, not an on-chain block: it prevents an accidental
 * click, not a direct `repay()` call.
 */
const QUARANTINED_RESERVE_ACCOUNTS: Address[] = [];

const quarantined = new Set(QUARANTINED_RESERVE_ACCOUNTS.map((address) => address.toLowerCase()));

export function isQuoteQuarantined(loan: Loan) {
  return quarantined.has(loan.borrower.toLowerCase());
}
